export function Accordion() {
  const acc = document.getElementsByClassName("accordion")
  let i

  for (i = 0; i < acc.length; i += 1) {
    acc[i].addEventListener("click", function click() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active")

      /* Toggle between hiding and showing the active panel */
      const panel = this.nextElementSibling
      if (panel.style.display === "block") {
        panel.style.display = "none"
      } else {
        panel.style.display = "block"
        panel.classList.toggle("panel-active")
      }
    })
  }
}
